
import { connect } from 'react-redux';
import { container } from 'op/container';

export const withErrorHandling =
	connect(null, (dispatch) => ({
		throwError: ({ message, details }) => 
			dispatch(container.resolve('actions').throw_error({ message, details }))
	}));

export const withNotifications =
	connect(({ notification }) => ({
		errors: notification.error || [],
	}), (dispatch) => ({
		dismissNotification: (notification_id) => 
			dispatch(container.resolve('actions').dismiss_notification(notification_id))
	}));